var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.loadingPage},[_c('LoadingBoxMobile',{class:_vm.$style.loadingBoxMobile})],1)}
var staticRenderFns = []

export { render, staticRenderFns }